<template>
	<el-container>
		<el-aside width="232px">
			<el-menu :default-active="active" class="left-menu" theme="dark" router unique-opened
				background-color="#393A40" text-color="#fff" active-text-color="#fff" @select="handleOpen">
				<div class="logo_title">后台UI规范</div>
				<el-menu-item index="/Worktable">
					<i class="el-icon-document"></i>
					<span slot="title">工作台</span>
				</el-menu-item>
				<el-menu-item index="/Qunit">
					<i class="el-icon-menu"></i>
					<span slot="title">资质单位</span>
				</el-menu-item>
				<el-menu-item index="/Qapplication" >
					<i class="el-icon-document"></i>
					<span slot="title">资质申请</span>
				</el-menu-item>
				<el-menu-item index="/Qmanagement">
					<i class="el-icon-setting"></i>
					<span slot="title">资质管理</span>
				</el-menu-item>
				<el-menu-item index="/DataStatistics">
					<i class="el-icon-setting"></i>
					<span slot="title">数据统计</span>
				</el-menu-item>
				<el-menu-item index="/Backlog">
					<i class="el-icon-setting"></i>
					<span slot="title">待办流程</span>
				</el-menu-item>
			</el-menu>
			<!-- <el-menu class="left-menu" background-color="#304156" text-color="#fff" active-text-color="#FFAEAE"
				:default-active="active" theme="dark" router>
				<el-menu-item index="/"><i class="el-icon-menu"></i>首页</el-menu-item>
				<el-submenu index="1">
					<template slot="title"><i class="el-icon-document"></i>人事管理</template>
					<el-menu-item index="/customerList">会员管理</el-menu-item>
					<el-menu-item index="userList">管理员列表</el-menu-item>
					<el-menu-item index="userList-change">管理员列表</el-menu-item>
				</el-submenu>
				<el-submenu index="2">
					<template slot="title"><i class="el-icon-message"></i>订单管理</template>
					<el-menu-item index="/list"><i class="el-icon-switch-button"></i>订单列表</el-menu-item>
					<el-submenu index="2-1">
						<template slot="title"><i class="el-icon-box"></i>退货管理</template>
						<el-menu-item index="/sellbacklist"><i class="el-icon-switch-button"></i>退货列表</el-menu-item>
						<el-menu-item index="/sellback"><i class="el-icon-box"></i>设置退货原因</el-menu-item>
					</el-submenu>
				</el-submenu>
				<el-submenu index="3">
					<template slot="title"><i class="el-icon-more"></i>产品管理</template>
					<el-menu-item index="/shopList">商铺列表</el-menu-item>
					<el-submenu index="3-1">
						<template slot="title">商品管理</template>
						<el-menu-item index="/product">商品列表</el-menu-item>
					</el-submenu>
				</el-submenu>
				<el-submenu index="4">
					<template slot="title"><i class="el-icon-sell"></i>添加数据</template>
					<el-menu-item index="/addShop"><i class="el-icon-s-home"></i>添加商铺</el-menu-item>
					<el-menu-item index="/productAdd"><i class="el-icon-s-goods"></i>添加商品</el-menu-item>
				</el-submenu>
				<el-submenu index="5">
					<template slot="title"><i class="el-icon-s-marketing"></i>图表</template>
					<el-menu-item index="/round"><i class="el-icon-location"></i>用户分布</el-menu-item>
				</el-submenu>
				<el-submenu index="6">
					<template slot="title"><i class="el-icon-setting"></i>设置</template>
					<el-menu-item index="myselfInfo">个人信息</el-menu-item>
				</el-submenu>
				<el-submenu index="7">
					<template slot="title"><i class="el-icon-warning"></i>说明</template>
					<!-- <el-menu-item index="explain">说明</el-menu-item> -->
			</el-submenu>
			</el-menu>
		</el-aside>
		<el-container>
			<el-header>
				<HeaderNav></HeaderNav>
			</el-header>
			<el-main>
				<keep-alive v-if="active!=''">
					<router-view></router-view>
				</keep-alive>
			</el-main>
		</el-container>
	</el-container>
</template>
<script>
	import HeaderNav from "../components//HeaderNav.vue";
	export default {
		data() {
			return {
				zhanghao: '',
				adminZS: false,
				vipZS: false,
				active: "/Worktable",
			};
		},
		mounted() {},
		computed: {
			defaultActive: function() {
				return this.$route.path.replace("/worktable", "");
			},
		},
		methods: {
			handleOpen(key, keyPath) {
				this.active = key
			},
		},
		components: {
			HeaderNav
		},
	};
</script>
<style lang="less" >
	@import "../style/mixin.less";

	.logo_title {
		height: 75px;
		color: #fff;
		text-align: center;
		font-size: 24px;
		font-weight: bold;
		line-height: 75px;
	}

	.manage_page {}

	.el-aside {
		text-align: left;
	}

	.el-header {
		height: 80px !important;
		padding: 0 !important;
	}

	.el-main {
		height: 200px;
		padding: 0 !important;
		box-sizing: border-box;
	}

	.ei-container {
		height: 100vh !important;
	}

	.el-menu-item.is-active {
		background-color: #616166 !important;
	}

	.left-menu {
		height: 100vh;
	}

	.left-con {
		height: 100%;
		overflow-y: auto;
		top: 0;
		bottom: 0;
		left: 0;
		width: 220px; // transition: width 10s;
		overflow-y: auto;

		&::-webkit-scrollbar {
			display: none;
		}
	}

	.main {
		height: 100%;
		overflow-y: auto;
		top: 0;
		bottom: 0;
		left: 0;
		width: 220px; // transition: width 10s;
		overflow-y: auto;

		&::-webkit-scrollbar {
			display: none;
		}
	}
</style>
